import useAxios from 'axios-hooks';
import ErrorAlert from 'components/ErrorAlert';
import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';

function Discover() {
  const [{ data, loading, error }, refetch] = useAxios('https://ping.evilgeniuslabs.org');

  // const data = {
  //   Items: [
  //     {
  //       userAgent: 'insomnia/2020.3.3',
  //       deviceName: "Jason's Work MacBook Pro",
  //       updatedAt: 1595206381112,
  //       millis: 1595185275846,
  //       sourceIp: '75.87.171.180',
  //       createdAt: 1594185322753,
  //       macAddress: 'f0:18:98:2b:48:c6',
  //       localIp: '192.168.86.249'
  //     }
  //   ],
  //   Count: 1,
  //   ScannedCount: 1
  // };
  // const loading = false;
  // const error = null;
  // const refetch = () => {};

  const { Items: items } = data || {};

  if (loading)
    return (
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    );

  if (error) return <ErrorAlert error={error} />;

  return (
    <>
      <button type="button" className="btn btn-primary" onClick={() => refetch()}>
        Refresh
      </button>

      {items ? (
        <div className="table-responsive">
          <table className="table table-sm table-striped table-hover">
            <thead>
              <tr>
                <th scope="col">Device Name</th>
                <th scope="col">IP Address</th>
                <th scope="col">Last Seen</th>
                <th scope="col">First Seen</th>
                <th scope="col">Uptime</th>
                <th scope="col">MAC Address</th>
              </tr>
            </thead>
            <tbody>
              {items
                .sort((a, b) => b.updatedAt - a.updatedAt)
                .map((item, index) => {
                  const { deviceName, localIp, updatedAt, createdAt, millis, macAddress } = item;
                  const duration = moment.duration(millis);
                  const humanDuration = duration.humanize();
                  const uptimeSeconds = duration.as('seconds').toLocaleString();

                  return (
                    <tr key={index}>
                      <td>{deviceName}</td>
                      <td>
                        <a href={`http://${localIp}`} target="_blank" rel="noreferrer noopener">
                          {localIp}
                        </a>
                      </td>
                      <td>
                        <Moment date={updatedAt} fromNow withTitle titleFormat="LLLL" />
                      </td>
                      <td>
                        <Moment date={createdAt} fromNow withTitle titleFormat="LLLL" />
                      </td>
                      <td>
                        <span title={`${uptimeSeconds} seconds`}>{humanDuration}</span>
                      </td>
                      <td>{macAddress}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No devices found.</p>
      )}
    </>
  );
}

export default Discover;
